import Vue from 'vue';
import VueResource from 'vue-resource';
import converterMoeda from '~js/converter-moeda';
import formatarData from '~js/formatar-data';
import converterObjetoFormData from '~js/converter-objeto-formdata';
import salvarArquivo from '~js/salvar-arquivo';

Vue.use(VueResource);

async function normalizarParaSalvar(solicitacao) {
  delete solicitacao.projeto;
  delete solicitacao.protocolo;

  if (solicitacao.dataPagamento) {
    solicitacao.dataPagamento = await formatarData.paraNumero(solicitacao.dataPagamento);
  }
  if (solicitacao.dataPartida) {
    solicitacao.dataPartida = await formatarData.paraNumero(solicitacao.dataPartida);
  }
  if (solicitacao.dataRetorno) {
    solicitacao.dataRetorno = await formatarData.paraNumero(solicitacao.dataRetorno);
  }

  solicitacao.despesasViajem.map(despesa => {
    delete despesa.rubrica;
    delete despesa.subrubrica;
    
    return despesa;
  });

  if (solicitacao.dataNascimento) {
    solicitacao.dataNascimento = await formatarData.paraNumero(solicitacao.dataNascimento);
  }
  
  // solicitacao.valor = converterMoeda.paraDolar(solicitacao.valor);

  return solicitacao;
}

async function normalizarParaVisualizar(solicitacao) {
  if (solicitacao.dataPagamento) {
    solicitacao.dataPagamento = formatarData.paraData(solicitacao.dataPagamento);
  }
  if (solicitacao.dataPartida) {
    solicitacao.dataPartida= formatarData.paraData(solicitacao.dataPartida);
  }
  else
    solicitacao.dataPartida = ""
    
  if (solicitacao.dataRetorno) {
    solicitacao.dataRetorno = formatarData.paraData(solicitacao.dataRetorno);
  }
  else
    solicitacao.dataRetorno = ""

  solicitacao.despesasViajem.map(despesa => {
      despesa.valorSolicitado = converterMoeda.paraReal(despesa.valorSolicitado);
    
    return despesa;
  });

  for (var i = 0; i < solicitacao.despesasViajem.length; i++) {
      for (var j = 0; j < solicitacao.despesasViajem[i].rateios.length; j++) {
          solicitacao.despesasViajem[i].rateios[j].valor = converterMoeda.paraReal(solicitacao.despesasViajem[i].rateios[j].valor);
      }
  }
 
  return solicitacao;
}

function normalizarParaDeclararDespesas(solicitacao) {
  let objeto = {
    rateios: []
  };
  
  solicitacao.despesasViajem.map(despesa => {
    despesa.rateios.map(rateio => {
      objeto.rateios.push(rateio);
    });
  });
  
  return objeto;
}

export default {
  lista: (pagina = 1, filtros) => {
    const parametros = Object.assign({}, { pagina }, filtros);

    const periodo = parametros.periodo;
    delete parametros.periodo;

    if (periodo) {
      parametros.dataInicio = moment(periodo[0], 'DD/MM/YYYY').format('MM/DD/YYYY');
      parametros.dataFim = moment(periodo[1], 'DD/MM/YYYY').format('MM/DD/YYYY');
    }
    
    return Vue.http.get('/api/solicitacaoadiantamentos', { params: parametros });
  },
  adicionar: async (solicitacao, arquivos) => {
    solicitacao = await normalizarParaSalvar(solicitacao);
    solicitacao.arquivos = arquivos;

    solicitacao = await converterObjetoFormData(solicitacao);

    return Vue.http.post('/api/solicitacaoadiantamentos', solicitacao).then(res => res.data.id);
  },
  alterar: async (solicitacao, arquivos, id) => {
    
    solicitacao = await normalizarParaSalvar(solicitacao);
    solicitacao.arquivos = arquivos;   
    solicitacao = await converterObjetoFormData(solicitacao);
 
    return Vue.http.put(`/api/solicitacaoadiantamentos/${id}`, solicitacao).then(res => res.data.id);
  },
  declararDespesas: (solicitacao, arquivos, id) => {
    solicitacao = normalizarParaDeclararDespesas(solicitacao);
    solicitacao.arquivos = arquivos;

    solicitacao = converterObjetoFormData(solicitacao);

    return Vue.http.put(`/api/solicitacaoadiantamentos/${id}/declarardespesas`, solicitacao).then(res => res.data.id);
  },
  obterPorId: id => {
    return Vue.http.get(`/api/solicitacaoadiantamentos/${id}`)
      .then(response => response.data)
      .then(solicitacao => normalizarParaVisualizar(solicitacao));
  },
  liberar: id => {
    return Vue.http.post(`/api/solicitacaoadiantamentos/${id}/liberar`)
      .then(response => response.data);
  },
  cancelar: id => {
    return Vue.http.post(`/api/solicitacaoadiantamentos/${id}/cancelar`)
      .then(response => response.data);
  },
  reenviarEmail: id => {
    return Vue.http.get(`/api/solicitacaoadiantamentos/${id}/reenviaremail`)
      .then(response => response.data);
  },
  arquivos: id => {
    return Vue.http.get(`/api/solicitacaoadiantamentos/${id}/arquivos`)
      .then(response => response.data);
  },
  download: (id, arquivo) => {
    return Vue.http.get(`/api/solicitacaoadiantamentos/${id}/downloadarquivo/${arquivo}`, {
      responseType: 'blob'
    })
      .then(response => {
        return salvarArquivo(response, arquivo);
      });
  },
  emAberto: cpf => {
    cpf = cpf.replace( /\-|\.|\/|\(|\)| /g, "" ); 

    return Vue.http.get(`/api/solicitacaoadiantamentos/emaberto/${cpf}`)
      .then(response => response.data);
  },
  pendenciaPorCpf: cpf => {
    cpf = cpf.replace( /\-|\.|\/|\(|\)| /g, "" ); 

    return Vue.http.get(`/api/solicitacaoadiantamentos/PendenciaPorCpf/${cpf}`)
      .then(response => response.data);
  },
  pendenciaPorProjeto: id => {
    return Vue.http.get(`/api/solicitacaoadiantamentos/PendenciaPorProjeto/${id}`)
      .then(response => response.data.resultado);
  },
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/solicitacao-adiantamento/servico.js